module.exports = __webpack_public_path__ + "gb.f22b0ee41f0a3116aa96.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/gb.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/gb.svg
// module chunks = styles